// src/contexts/WebsiteContext.js - opravená verze

import React, { createContext, useContext } from 'react';

// Vytvoření kontextu
const WebsiteContext = createContext({
    websiteId: null,
    website: null,
    activeTab: 'overview',
    setActiveTab: () => {},
    isLoading: false,
    error: null,
    navigateBack: () => {}
});

// Custom hook pro použití kontextu
export const useWebsiteContext = () => useContext(WebsiteContext);

// Provider komponenta
export const WebsiteProvider = ({ children, value }) => {
    return (
        <WebsiteContext.Provider value={value}>
            {children}
        </WebsiteContext.Provider>
    );
};

export default WebsiteContext;